import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaResumenId: 0,
    banco: '',
    tarjetaMarca: '',
    numeroCuenta: '',
    fechaCierre: '1900-01-01',
    fechaVencimiento: '1900-01-01',
    totalCierre: 0,
    totalPagos: 0,

    pagos: [],
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, tarjetaResumenId) {
        state.tarjetaResumenId = tarjetaResumenId;
        state.banco = '';
        state.tarjetaMarca = '';
        state.numeroCuenta = '';
        state.fechaCierre = '1900-01-01';
        state.fechaVencimiento = '1900-01-01';
        state.totalCierre = 0;
        state.totalPagos = 0;

        state.pagos = [];
    },
    'SET_TARJETA_RESUMEN' (state, tarjetaResumen) {
        state.banco = tarjetaResumen.banco;
        state.tarjetaMarca = tarjetaResumen.tarjetaMarca;
        state.numeroCuenta = tarjetaResumen.numeroCuenta;
        state.fechaCierre = moment(tarjetaResumen.fechaCierre).format('YYYY-MM-DD');
        state.fechaVencimiento = moment(tarjetaResumen.fechaVencimiento).format('YYYY-MM-DD');
        state.totalCierre = parseFloat(tarjetaResumen.importeConsumos) + parseFloat(tarjetaResumen.importeGastos);
        state.totalPagos = parseFloat(tarjetaResumen.importePagado);
    },    
    'INICIALIZAR_PAGOS' (state) {
        state.pagos = [];
    },
    'SET_PAGOS' (state, pagos) {
        state.pagos = pagos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar( { commit }, tarjetaResumenId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', tarjetaResumenId);

            apiAxios.get('tarjetasresumenes/' + tarjetaResumenId + '/vencimiento')
                .then(res => {
                    commit('SET_TARJETA_RESUMEN', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getTarjetaResumenPagos ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PAGOS');
            
            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            apiAxios.get('tarjetasresumenes/' + state.tarjetaResumenId + '/pagos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_PAGOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, tarjetaResumenPagoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('tarjetasresumenes/pagos/' + tarjetaResumenPagoId + '/delete')
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}